import React, { useContext, useEffect, useState } from 'react'
import imgIcon from '../../assets';
import PendingIcon from '@mui/icons-material/Pending';
import { IconDetalis } from '../../common/IconDetalis';
import { useNavigate } from 'react-router-dom';
import { LeftRightlayout } from '../Container/LeftRightlayout';
import { Input } from '../Components/Input';
import { buttonClass, Icon } from '../../common/CSS';
import { Header } from '../Container/Header';
import { Buttons } from '../../common/Buttons';
import FormContextApi from '../../ContextApi';
import { useDispatch, useSelector } from 'react-redux';
import { setErrorUndefined, signUpWithOtp, loginWithOTP, resendOtp } from '../../actions/auth';
import { isLogged } from '../../utils/common';
import { gtag } from 'ga-gtag';

export default function VerifyOtp() {
    const dispatch = useDispatch();
    const { userInit, loginMobile } = useContext(FormContextApi);
    let { error } = useSelector((store) => store.authreducer);
    let { formButtonLoading } = useSelector((store) => store.loadingreducer);
    let { otp } = useSelector((store) => store.authreducer);
    const isLoggedIn = isLogged();
    const [seconds, setSeconds] = useState(20);
    const [btnDisable, setBtnDisable] = useState(false);
    const [otpi, setOtp] = useState('');
    const [otpresend, setotpresend] = useState(true);
    const formName = 'otpForm';
    const navigate = useNavigate();

    useEffect(() => {
        document.title = 'Verify Otp';
    }, []);

    useEffect(() => {
        if (isLoggedIn) {
            navigate('/service');
        }
    }, [isLoggedIn, navigate]);

    useEffect(() => {
        let interval = null;
        if (seconds !== 0) {
            interval = setInterval(() => {
                setSeconds((seconds) => seconds - 1);
            }, 1000);
        } else if (seconds === 0) {
            setotpresend(false);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [seconds]);

    useEffect(() => {
        if (otpi.length === 4) {
            setBtnDisable(false);
        } else {
            dispatch(setErrorUndefined());
            setBtnDisable(true);
        }
    }, [otpi, dispatch]);

    if (userInit?.mobile === '' || userInit?.mobile === undefined || userInit?.mobile === null) {
        navigate('/userdetails');
    }

    const resendOtpHandler = () => {
        setotpresend(true);
        setSeconds(20);
        if (otp?.message === 'loginwithmobilenumber') {
            let mobile = userInit?.mobile;
            dispatch(resendOtp(mobile, 'CUSTOMER', 'loginMobile'));
        } else {
            dispatch(resendOtp(userInit?.mobile, 'CUSTOMER', 'registerWithMobile'));
        }
    };

    const setGtag = (eventName) => {
        gtag('event', 'Click', {
            [eventName]: 'button',
        });
    };

    const submit = () => {
        if (otp?.message === 'loginwithmobilenumber') {
            let mobile = userInit?.mobile;
            dispatch(loginWithOTP(mobile, otpi, formName, navigate, setGtag));
        } else {
            dispatch(signUpWithOtp(userInit, otpi, formName, navigate, setGtag));
        }
    };

    const handleFormSubmit = (event) => {
        if (event.which === 13 || event.key === 'Enter') {
            event.preventDefault();
            submit();
        } else if (event.type === 'click') {
            event.preventDefault();
            submit();
        }
    };

    const Content = () => {
        return (
            <>
                <Header showButton path='/userdetails' />
                <div className='mt-4'>
                    <div className={Icon.HeadingIcon}>
                        <IconDetalis coloreIcon='text-darkblue' IconName='manage_accounts' IconHeading='Your Details' />
                        <IconDetalis coloreIcon='text-stardust' IconName='devices' IconHeading='Select Service' />
                        <IconDetalis coloreIcon='text-stardust' IconName='currency_rupee' IconHeading='Payment' />
                        <IconDetalis coloreIcon='text-stardust' IconName='engineering' IconHeading='Get Engineer' />
                        <div className='w-110F rounded-none bg-darkblue h-3P mt-3 checkBoxPanding'>
                            <PendingIcon />
                        </div>
                        <div className='w-110F rounded-none bg-stardust h-3P mt-3'></div>
                        <div className='w-110F rounded-none bg-stardust h-3P mt-3'></div>
                        <div className='w-full rounded-none bg-stardust h-3P mt-3'></div>
                    </div>
                </div>

                <div className='w-11/12 p-2 m-auto'>
                    <div className='text-center mt-4'>
                        <h1 className='text-22F'>Verify Mobile Number</h1>
                        <p className='text-17F mt-4 text-stardust'>Enter the 4-digit code sent to {userInit?.mobile || loginMobile?.logmobile}</p>
                    </div>

                    <form onKeyPress={(event) => handleFormSubmit(event)}>
                        <div className='mt-6 text-center'>
                            <Input type='otp' name='otp' otperror={error === undefined ? null : error} required otp={otpi} setOtp={setOtp} />
                        </div>
                        <div className='px-6 pb-2 pt-3 mt-4'>
                            <Buttons
                                loading={formButtonLoading?.[formName]}
                                btnText='Submit'
                                disabled={btnDisable}
                                classN={`${buttonClass?.scogoOrange}`}
                                onClick={(e) => handleFormSubmit(e)}
                            />
                        </div>
                    </form>
                </div>
                <div className='text-center'>
                    {otpresend ? (
                        <span>
                            Resend Code in
                            <span className='text-scogoprimary font-medium '> 00:{seconds}</span>{' '}
                        </span>
                    ) : (
                        <sapn onClick={() => resendOtpHandler()} className='text-scogoprimary font-medium underline cursor-pointer'>
                            Resend now
                        </sapn>
                    )}
                </div>
            </>
        );
    };

    const Imgsection = () => {
        return (
            <>
                <div className='bg-scogolightwhite m-auto h-screen w-68P mt-2'>
                    <div className='m-auto h-5/6 w-68P'>
                        <img width='100%' className='m-auto h-5/6 mt-16' src={imgIcon.Verification} alt='' />
                    </div>
                </div>
            </>
        );
    };

    return (
        <>
            <LeftRightlayout Content={Content} RightImg={Imgsection} />
        </>
    );
}
